<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
      message_sent: false,
      contactform: {
        name: '',
        email: '',
        phone: '',
        Address: '',
        City: '',
        StateOrProvince: '',
        PostalCode: '',
        comments: "You currently do not cover the property I would like to list. I would like to be notified once your services are available in my area.",
        recaptcha_token: '',
      },
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    async contactus() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      this.contactform.Address = this.item.Address;
      this.contactform.City = this.item.City;
      this.contactform.StateOrProvince = this.item.StateOrProvince;
      this.contactform.PostalCode = this.item.PostalCode;
      this.contactform.recaptcha_token = await this.getRecaptcha();
      if(
        !this.contactform.recaptcha_token ||
        this.contactform.recaptcha_token == 'failed'
      ) {
        this.$noty.error("There was an issue with the Google ReCaptcha validation. Please try refreshing the page, if this does not solve the issue please reach out to us.");
        this.loading = false; return;
      }

      this.$http.post('/inbox/not-servicing', this.contactform).then(res => {
        console.log(res);
        this.message_sent = true;
        this.loading = false;
      }).catch(res => { console.log(res); this.loading = false; this.popupErrors(res); });
    },
    submit_form() {
      this.$emit('setpage', 1);
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="title text-center mb-5">
        <!-- <i class="mdi mdi-message-outline h1 text-primary mb-3" data-aos="fade-zoom-in"></i> -->
        <img :src="formatImage('/fm/revinre-nc/clip art/Not servicing.png')" class="" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Not servicing your area</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Currently, we are not available in your area. Sorry for the inconvenience. We are continuously working to grow and increase our coverage. Would you like to be notified once we are available in your area?</p>
        <div v-if="message_sent">
          <div class="alert alert-info text-center mt-4">We will notify you once our services are offered in your area.</div>
        </div>
        <div v-else>
          <div class="my-4 small">
            <p class="small text-muted">By submitting you agree to {{app_name}}'s <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms" target="_blank">Terms & Conditions</a>.</p>
            <p class="small text-muted">This site is protected by ReCaptcha and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</p>
          </div>
          <button type="button" class="btn btn-lg btn-info" @click="contactus()" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Yes, please notify me</button>
        </div>
      </div>

      <div class="row py-5">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 1)"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">

        </div>
      </div>
    </form>
  </div>

</template>
